import React, { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import withWidth from '@material-ui/core/withWidth';
import MenuIcon from '@material-ui/icons/Menu';
import Control from "react-leaflet-control";
import L from 'leaflet';
import FullscreenControl from 'react-leaflet-fullscreen';
import CurrentLocation from '../../currentlocation/CurrentLocation';
import { styles } from './Style';
import 'leaflet/dist/leaflet.css';
import {
  Map,
  Marker,
  TileLayer,
  GeoJSON,
  LayerGroup,
  LayersControl,
  Tooltip,
  WMSTileLayer,
} from "react-leaflet";
import WaterLevelStatusColor from '../../forecast/floodforecast/FloodforecastMap/WaterLevelStatusColor';
import { fetchAllLatestWl } from '../../forecast/floodforecast/FloodforecastMap/fetchLatestObserve';
import FloodForecastChart from '../../forecast/floodforecast/FloodforecastMap/FloodForecastChart';
import { uniqueId } from 'lodash';
import iconImage from '../../widgets/map/iconImage';
import { Hidden } from '@material-ui/core';
import RainfallStatusColor from '../../rainfall/map/RinfallStatusColor';
import { Table, TableBody, TableRow, TableCell, TableHead, TableContainer, Box, Button } from '@material-ui/core';
import { Popup } from 'react-leaflet';
import formatNumber from '../../../utils/number/Number';
import { RainIcon } from '../../../assets/svg/Icon';
import DamLargeColor from '../../../components/color/dam/DamLargeColor';
import DamMediumColor from '../../../components/color/dam/DamMediumColor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faSquare } from '@fortawesome/free-solid-svg-icons';
import Typography from '@material-ui/core/Typography';
import { FaChartLine } from '../../../utils/Fontawesome';
import DamChartDailyMain from '../../dam/chart/daily/DamChartDailyMain';
import DamChartDailyMediumMain from '../../dam/chart/daily/DamChartDailyMediumMain';
import { Dam1Icon, Dam2Icon, Dam3Icon, Dam4Icon, Dam5Icon, } from '../../../assets/svg/Icon';
import DamLargeLegendRRI from './DamLargeLegendRRI';
import { RRIGeotiffLayer } from '../../flashflood/flashflood/GeotiffLayer';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { throttle } from 'lodash';
import 'plotty';
import 'leaflet-geotiff';
import '../../flashflood/flashflood/LeafletGeotiffPlotty';
import Paper from "@material-ui/core/Paper";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import LegendRRI from './LegendRRI';
import RRIGeotiffLayerRRI from './RRIGeotiffLayerRRI';
import LegendObsRain from '../../flashflood/flashflood/LegendObsRain';
import DischargeLegend from './DischageLegend';
// import { RRI_STATION_META, RRI_RESERVOIR_META, getReservoirId } from './RRIStation';
const { BaseLayer } = LayersControl;

const initPathWMS1 = process.env.REACT_APP_WMS;
const jawgToken = process.env.REACT_APP_JAWG_TOKEN;

// const rriQrOptions = {
//   name: 'RRI_QR',
//   band: 0,
//   opacity: 1,
//   displayMin: 1,
//   displayMax: 4500,
//   colorScale: 'qrSpatialColorscale',
//   clampLow: false,
//   clampHigh: true,
// };

const getQrColor = (qr) => {
  if (qr === null || qr === undefined || isNaN(qr)) return '#75808d';
  if (qr <= 0.1)   return '#FFFFFF';
  if (qr <= 50)    return '#E1F5FE';
  if (qr <= 150)   return '#81D4FA';
  if (qr <= 350)   return '#29B6F6';
  if (qr <= 550)   return '#1976D2';
  if (qr <= 750)   return '#5E35B1';
  if (qr <= 1000)  return '#8E24AA';
  if (qr <= 1250)  return '#C2185B';
  if (qr <= 1500)  return '#E53935';
  if (qr <= 1800)  return '#F4511E';
  if (qr <= 2100)  return '#E64A19';
  if (qr <= 2400)  return '#D32F2F';
  if (qr <= 2700)  return '#B71C1C';
  if (qr <= 4000)  return '#7F0000';
  return '#7F0000';
};

const getContrastColor = (hexColor) => {
  if (!hexColor || hexColor === '#75808d') return '#FFFFFF';
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};

const RRI_STATUS_COLOR = {
  normal:   '#14875d', // ปกติ
  watch:    '#DFC328', // เฝ้าระวัง (alarm)
  warning:  '#ED9B4D', // เตือนภัย (warning)
  critical: '#C83C35', // วิกฤต (critical)
  nodata:   '#9E9E9E', // ไม่มีข้อมูล
};

const getRriStationColor = (qr, th) => {
  if (qr == null || isNaN(qr) || !th) return RRI_STATUS_COLOR.nodata;
  if (th.critical != null && qr >= th.critical) return RRI_STATUS_COLOR.critical;
  if (th.warning  != null && qr >= th.warning)  return RRI_STATUS_COLOR.warning;
  if (th.alarm    != null && qr >= th.alarm)    return RRI_STATUS_COLOR.watch;
  return RRI_STATUS_COLOR.normal;
};

const RAINFALL_LEGEND_TITLE = {
  rainfallToday: 'เกณฑ์ฝนตรวจวัดวันนี้ (มม.)',
  rainfallYesterday: 'เกณฑ์ฝนตรวจวัดวานนี้ (มม.)',
  rainfall24h: 'เกณฑ์ฝนตรวจวัด 24 ชม. (มม.)',
  rainfall3day: 'เกณฑ์ฝนตรวจวัด 3 วัน (มม.)',
  rainfall7day: 'เกณฑ์ฝนตรวจวัด 7 วัน (มม.)',
  rainfall15day: 'เกณฑ์ฝนตรวจวัด 15 วัน (มม.)',
  rainfall30day: 'เกณฑ์ฝนตรวจวัด 30 วัน (มม.)',
};

class RRIMap extends Component {
  constructor(props) {
    super(props);
    this.refMap = createRef();
    this.refBoundaryBasin = createRef();
    this.refGeotiffRri = createRef();
    this.iconCache = {
      rain: Object.create(null),
      waterLevel: Object.create(null),
      damMedium: Object.create(null),
      damLarge: Object.create(null),
      reservoir: Object.create(null),
    };
    this.rainfallMarkersCache = {
      source: null,
      rainfallType: null,
      t: null,
      markers: [],
    };
    this.state = {
      geojsonBasin: [],
      error: '',
      latestWlMap: {},
      openLegendRRI: false,
      openLegendObsRain: false,
      openLegendDamLarge: false,
      openLegendReservoir: false,
      openLegendStation: false,
      tiffTooltip: null,
      showInfo: false,
    };
  }

  createSvgMarkerIcon = (svgMarkup, iconSize, iconAnchor) => L.icon({
    iconUrl: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgMarkup)}`,
    iconSize,
    iconAnchor,
    popupAnchor: [0, -Math.round(iconSize[1] / 2)],
    tooltipAnchor: [0, -Math.round(iconSize[1] / 2)],
  });

  getCachedSvgIcon = (group, key, svgMarkup, iconSize, iconAnchor) => {
    if (!this.iconCache[group][key]) {
      this.iconCache[group][key] = this.createSvgMarkerIcon(svgMarkup, iconSize, iconAnchor);
    }

    return this.iconCache[group][key];
  };
  
  handleMapMouseMove = throttle((e) => {
    const { rriTifEnabled, rriTifUrl } = this.props;
    if (!rriTifEnabled || !rriTifUrl) return;

    const layer = this.refGeotiffRri.current?.leafletElement;
    if (!layer) return;

    try {
      const { lat, lng } = e.latlng;
      const georaster = layer.georasters?.[0];
      if (!georaster) return;

      const { xmin, xmax, ymin, ymax, width, height, values } = georaster;

      if (lng < xmin || lng > xmax || lat < ymin || lat > ymax) {
        this.setState({ tiffTooltip: null });
        return;
      }

      const col = Math.floor((lng - xmin) / (xmax - xmin) * width);
      const row = Math.floor((ymax - lat) / (ymax - ymin) * height);
      const value = values[0]?.[row]?.[col];

      if (value !== null && value !== undefined && !isNaN(value) && value > 0.1) {
        this.setState({
          tiffTooltip: {
            x: e.originalEvent.clientX,
            y: e.originalEvent.clientY,
            value: value.toFixed(2),
            color: getQrColor(value),
          },
        });
      } else {
        this.setState({ tiffTooltip: null });
      }
    } catch {
      this.setState({ tiffTooltip: null });
    }
  }, 50);

  handleMapMouseOut = () => {
    this.setState({ tiffTooltip: null });
  };

  handleClickLegendRRI = () => {
    const { openLegendRRI } = this.state;

    if (openLegendRRI === false) {
      this.setState({ openLegendRRI: true });
    } else {
      this.setState({ openLegendRRI: false });
    }
  };

  handleClickLegendObsRain = () => {
    const { openLegendObsRain } = this.state;
    if (openLegendObsRain === false) {
      this.setState({ openLegendObsRain: true });
    } else {
      this.setState({ openLegendObsRain: false });
    }
  };

  handleClickLegendDamLarge = () => {
    this.setState(prev => ({ openLegendDamLarge: !prev.openLegendDamLarge }));
  };

  handleClickLegendReservoir = () => {
    this.setState(prev => ({ openLegendReservoir: !prev.openLegendReservoir }));
  };

  handleClickLegendStation = () => {
    this.setState(prev => ({ openLegendStation: !prev.openLegendStation }));
  };
  
  componentDidUpdate(prevProps) {
    const { datas } = this.props;
    if (prevProps.datas?.length === 0 && datas?.length > 0) {
      const validWl = datas.filter(d => d[0] && d[0] !== 'code' && d[0] !== '-');
      fetchAllLatestWl(validWl).then(map => {
        this.setState({ latestWlMap: map });
      });
    }
  }

// เพิ่ม method
handleRainfallChart = (id, type, teleStationData, teleStationThis) => () => {
  const { handleModalOpen, t } = this.props;
    handleModalOpen({
      header: t('กราฟคาดการณ์น้ำท่า-ระดับน้ำในแม่น้ำสายหลัก'),
      content: (
        <FloodForecastChart
          name={id}
          type={type}
          teleStation={teleStationData}
          teleStationThis={teleStationThis}
        />
      ),
    });
  };

  // เพิ่ม bindMarker
  bindMarker = (id) => (ref) => {
    const { markers } = this.props;
    if (ref) {
      markers[id] = ref.leafletElement;
      markers[id].addEventListener('click', (e) => {
        this.refMap.current.leafletElement.panTo(e.target.getLatLng());
      });
    }
  };

  getGeoJson() {
    fetch('json/boundary/basin.json')
      .then(res => res.json())
      .then(basin => this.setState({ geojsonBasin: basin }))
      .catch(error => this.setState({ error }));
  }

  getBasinStyle() {
    return { stroke: true, color: '#434348', weight: 1,
      fillColor: '#b1b1f7', opacity: 1, fillOpacity: 0.3 };
  }

  highlightFeature = (e) => {
    const layer = e.target;
    layer.setStyle({
      fillOpacity: 0.6,
      stroke: true,
      color: "#434348",
    });
    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
    layer
      .bindTooltip(`<h4>${layer.feature.properties.BASIN_T}</h4>`)
      .openTooltip();
  };

  resetHighlight = (e) => {
    this.refBoundaryBasin.current.leafletElement.resetStyle(e.target);
  };

  onEachBasinFeature = (feature, layer) => {
    layer.on({
      mouseover: this.highlightFeature,
      mouseout: this.resetHighlight,
    });
  };

  componentDidMount() {
    const { handleSetMap  } = this.props;
    const map = this.refMap.current.leafletElement;
    this.getGeoJson();
    handleSetMap(map);
  }

  eachData = (data, i) => {
    const { datas } = this.props;
    const { latestWlMap } = this.state;

    if (data[3] && data[4] != null) {
      const position = [parseFloat(data[3]), parseFloat(data[4])];
      const latestValue = latestWlMap[data[0]] ?? null;
      const status = WaterLevelStatusColor(latestValue, data, 'wl');
      const fillColor = (typeof status?.color === 'string' ? status.color : status?.color?.statusColor) ?? '#DB802B';
      const icon = this.getWaterLevelSvgIcon(fillColor);

      return (
        <Marker
          key={i}
          position={position}
          icon={icon}
          onClick={this.handleRainfallChart(data[0], 'wl', datas, data)}
          ref={this.bindMarker(data[0])}
        >
          <Tooltip>
            <span>
              <strong>{data[0]} สถานี {data[2]}</strong>
              <br />{data[11]} {data[12]} {data[13]}
            </span>
          </Tooltip>
        </Marker>
      );
    }
    return false;
  };

getRainfallData = () => {
  const {
    rainfallType,
    dataRainfall24,
    datasRainTodayMarker,
    datasRainYesterday,
    datasRain3day,
    datasRain7day,
    datasRain15Day,
    datasRain30Day,
  } = this.props;

  switch (rainfallType) {
    case 'rainfallYesterday': return datasRainYesterday ?? [];
    case 'rainfallToday':     return datasRainTodayMarker ?? [];
    case 'rainfall24h':       return dataRainfall24 ?? [];
    case 'rainfall3day':      return datasRain3day ?? [];
    case 'rainfall7day':      return datasRain7day ?? [];
    case 'rainfall15day':     return datasRain15Day ?? [];
    case 'rainfall30day':     return datasRain30Day ?? [];;
    default: return [];
  }
};

PopupRainfall = (data, value, stationName, provinceName) => {
  const { t, rainfallType, classes } = this.props;
  const status = RainfallStatusColor(parseFloat(value), rainfallType);
  const rainfallStatus = status.color.statusColor;
  const textRainfallStatus = status.color.constrastColor;
  const amphoeName = data.geocode?.amphoe_name?.th ?? data.amphoe_name?.th ?? '';
  const tumbonName = data.geocode?.tumbon_name?.th ?? data.tumbon_name?.th ?? '';
  const agencyName = data.agency?.agency_name?.th ?? data.agency_name?.th ?? '';
  const datetime = data.rainfall_datetime ?? data.rainfall_end_date ?? '';
  const oldCode = data.station?.tele_station_oldcode ?? data.tele_station_oldcode ?? '';

  return (
    <TableContainer style={{ minWidth: 280 }}>
      <Table size="small">
        <TableHead />
        <TableBody>
          <TableRow>
            <TableCell padding="none" align="center" colSpan={3}>
              <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">{oldCode ? `${oldCode} ${stationName}` : stationName}</Box>
              <Box fontFamily="Kanit" fontSize="12px">{` ต.${tumbonName} อ.${amphoeName} จ.${provinceName}`}</Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell padding="none" align="center" colSpan={3}>
              <Box py={3} display="flex" justifyContent="center" alignItems="center">
                <RainIcon style={{ fontSize: '4rem', fill: rainfallStatus }} />
                <Box>
                  <Box p={1} fontFamily="Kanit" bgcolor={rainfallStatus} color={textRainfallStatus} border={rainfallStatus === '#ffffff' ? 1 : undefined}>
                    {formatNumber(value)}
                  </Box>
                  <Box fontFamily="Kanit" fontSize={12}>({t('มม.')})</Box>
                </Box>
              </Box>
              <Box mb={2} fontSize="16px" fontFamily="Kanit">{t('ปริมาณฝน')}</Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3}>
              <Box color="text.disabled" fontSize="8px">{`${t('ข้อมูล')}: ${agencyName}`}</Box>
              <Box color="text.disabled" fontSize="8px">{`${t('ล่าสุด')} : ${datetime}`}</Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

eachRainfallMarker = (data, i) => {
  const { rainfallType, t } = this.props;
  const lat = data.station?.tele_station_lat ?? data.tele_station_lat;
  const lng = data.station?.tele_station_long ?? data.tele_station_long;
  if (!lat || !lng) return null;

  let value = null;
  if (rainfallType === 'rainfall24h')       value = data.rain_24h;
  if (rainfallType === 'rainfallToday')     value = data.rainfall_value;
  if (rainfallType === 'rainfallYesterday') value = data.rainfall_value;
  if (rainfallType === 'rainfall3day')      value = data.rain_3d;
  if (rainfallType === 'rainfall7day')      value = data.rain_7d;
  if (rainfallType === 'rainfall15day')     value = data.rain_15d;
  if (rainfallType === 'rainfall30day')     value = data.rainfall_value;
  if (value === null || value === undefined) return null;

  if (value === null || value === undefined) return null;

  const status = RainfallStatusColor(parseFloat(value), rainfallType);
  const fillColor = status?.color?.statusColor ?? '#bdbdbd';
  const position = [parseFloat(lat), parseFloat(lng)];
  const stationName = data.station?.tele_station_name?.th ?? data.tele_station_name?.th ?? '';
  const provinceName = data.geocode?.province_name?.th ?? data.province_name?.th ?? '';
  const amphoeName = data.geocode?.amphoe_name?.th ?? data.amphoe_name?.th ?? '';
  const tumbonName = data.geocode?.tumbon_name?.th ?? data.tumbon_name?.th ?? '';
  const oldCode = data.station?.tele_station_oldcode ?? data.tele_station_oldcode ?? '';
  // const icon = this.getRainSvgIcon(fillColor);

  return (
    <Marker key={`rainfall-${i}`} position={position} icon={status.icon}>
      <Tooltip>
        <span>
          <strong>{oldCode ? `${oldCode} ${stationName}` : stationName}</strong><br />
          {`ต.${tumbonName} อ.${amphoeName} จ.${provinceName}`}<br />
          {`${t('ปริมาณฝน')} `}<strong>{value}</strong>{` ${t('มม.')}`}
        </span>
      </Tooltip>
      <Popup autoPan={false}>
        {this.PopupRainfall(data, value, stationName, provinceName)}
      </Popup>
    </Marker>
  );
  };

  getRainfallMarkers = () => {
    const rainfallData = this.getRainfallData();
    const { rainfallType, t } = this.props;
    const cache = this.rainfallMarkersCache;

    if (cache.source === rainfallData && cache.rainfallType === rainfallType && cache.t === t) {
      return cache.markers;
    }

    const markers = rainfallData.map(this.eachRainfallMarker);
    this.rainfallMarkersCache = {
      source: rainfallData,
      rainfallType,
      t,
      markers,
    };

    return markers;
  };

  getRainSvgIcon = (color) => {
    const iconColor = getContrastColor(color);
    const svgMarkup = `<svg width="22" height="22" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="60" rx="30" fill="${color}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M34.1646 48.435C34.5846 47.58 34.5846 43.875 34.5846 43.875C34.5846 43.875 31.5846 46.05 31.1346 46.71C30.6846 47.58 31.1346 48.645 31.7946 49.095C32.6496 49.515 33.7296 49.095 34.1796 48.435H34.1646Z" fill="${iconColor}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.5609 49.095C27.4309 49.515 28.5259 49.095 28.9459 48.435C29.1559 47.58 29.3959 43.875 29.3959 43.875C29.3959 43.875 26.3509 46.05 25.9159 46.71C25.4959 47.58 25.7059 48.645 26.5759 49.095H26.5609Z" fill="${iconColor}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35.2894 42.8101C36.1444 43.2301 37.2244 43.0201 37.6744 42.1501C38.0944 41.2951 38.0944 37.6201 38.0944 37.6201C38.0944 37.6201 35.0944 39.7651 34.6444 40.6201C34.1944 41.4751 34.6444 42.3751 35.3044 42.7951L35.2894 42.8101Z" fill="${iconColor}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M30.9391 42.1501C31.3891 41.2951 31.3891 37.6201 31.3891 37.6201C31.3891 37.6201 28.3441 39.7651 27.8941 40.6201C27.4741 41.4751 27.8941 42.3751 28.7941 42.7951C29.4091 43.2151 30.5191 43.0051 30.9391 42.1351V42.1501Z" fill="${iconColor}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M24.6555 42.1501C25.1055 41.2951 25.3155 37.6201 25.3155 37.6201C25.3155 37.6201 22.2705 39.7651 21.8655 40.6201C21.4155 41.4751 21.6255 42.3751 22.4805 42.7951C23.3805 43.2151 24.2355 43.0051 24.6555 42.1351V42.1501Z" fill="${iconColor}"/>
      <path d="M39.9999 36.03H20.1849C15.6249 36.03 11.9199 32.325 11.9199 27.765C11.9199 23.205 15.4299 19.695 19.8249 19.515C20.3199 15.015 24.1449 11.49 28.7799 11.49C32.6199 11.49 35.9799 13.965 37.2249 17.49C38.1249 17.22 39.0549 17.07 39.9999 17.07C45.2349 17.07 49.4799 21.33 49.4799 26.55C49.4799 31.77 45.2199 36.03 39.9999 36.03ZM20.1849 22.365C17.2149 22.365 14.7849 24.795 14.7849 27.765C14.7849 30.735 17.1999 33.165 20.1849 33.165H39.9999C43.6449 33.165 46.6149 30.195 46.6149 26.55C46.6149 22.905 43.6449 19.935 39.9999 19.935C38.9049 19.935 37.8699 20.19 36.9099 20.7L35.1099 21.66L34.8249 19.635C34.4049 16.62 31.8099 14.355 28.7799 14.355C25.3899 14.355 22.6449 17.1 22.6449 20.49C22.6749 20.73 22.6899 20.835 22.7049 20.94L22.8249 22.74L21.0399 22.455C20.7549 22.41 20.4699 22.365 20.1849 22.365Z" fill="${iconColor}"/>
    </svg>`;

    return this.getCachedSvgIcon('rain', `${color}-${iconColor}`, svgMarkup, [22, 22], [11, 11]);
  };

  getWaterLevelSvgIcon = (color) => {
    const iconColor = getContrastColor(color);
    const svgMarkup = `<svg width="24" height="24" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="61" height="61" rx="30.5" fill="${color}"/>
        <path d="M20.1202 20.5605H21.354V15.6912C21.354 15.5468 21.2359 15.4155 21.0784 15.4155H16.1565C16.0121 15.4155 15.8809 15.5468 15.8809 15.6912V36.5862C15.8809 36.7305 16.0121 36.8618 16.1565 36.8618H21.0784C21.2227 36.8618 21.354 36.7437 21.354 36.5862V35.313H20.1202C19.8709 35.313 19.6609 35.103 19.6609 34.8537C19.6609 34.6043 19.8709 34.3812 20.1202 34.3812H21.354V31.8612H20.1202C19.8709 31.8612 19.6609 31.6512 19.6609 31.3887C19.6609 31.1262 19.8709 30.9162 20.1202 30.9162H21.354V28.3962H20.1202C19.8709 28.3962 19.6609 28.1862 19.6609 27.9237C19.6609 27.6612 19.8709 27.4512 20.1202 27.4512H21.354V24.9312H20.1202C19.8709 24.9312 19.6609 24.7212 19.6609 24.4718C19.6609 24.2224 19.8709 23.9993 20.1202 23.9993H21.354V21.4793H20.1202C19.8709 21.4793 19.6609 21.2693 19.6609 21.0068C19.6609 20.7443 19.8709 20.5474 20.1202 20.5474V20.5605ZM19.0571 19.1562C18.2302 19.1562 17.5609 18.4605 17.5609 17.6205C17.5609 16.7805 18.2302 16.0849 19.0571 16.0849C19.884 16.0849 20.5665 16.7805 20.5665 17.6205C20.5665 18.4605 19.8971 19.1562 19.0571 19.1562Z" fill="${iconColor}"/>
        <path d="M48.4826 40.7338C46.1988 38.6469 44.1382 38.7781 42.8257 39.2375C41.5788 39.6838 40.7388 40.5106 40.5026 40.7731C37.5101 43.4506 35.2263 40.9963 35.082 40.8388C35.0426 40.7994 35.0163 40.7731 34.977 40.7338C32.6932 38.6469 30.6326 38.7781 29.3201 39.2375C28.0732 39.6838 27.2332 40.5106 26.997 40.7731C24.0045 43.4506 21.7207 40.9963 21.5763 40.8388C21.537 40.7994 21.5107 40.7731 21.4713 40.7338C19.1876 38.6469 17.127 38.7781 15.8145 39.2375C14.4101 39.7363 13.5307 40.7206 13.4388 40.8388C12.9926 41.3638 12.9401 42.2956 13.3207 42.9125C13.7013 43.5294 14.3838 43.6081 14.8301 43.0831C14.8563 43.0569 17.1795 40.4056 20.2507 43.1488C20.487 43.4113 21.3138 44.2381 22.5738 44.6844C23.8863 45.1569 25.947 45.275 28.2307 43.1881C28.2701 43.1619 28.2963 43.1225 28.3357 43.0831C28.362 43.0569 30.6851 40.4056 33.7563 43.1488C33.9926 43.4113 34.8195 44.2381 36.0795 44.6844C36.5388 44.8419 37.0901 44.9731 37.707 44.9731C38.862 44.9731 40.2532 44.5531 41.7363 43.2013C41.7757 43.1619 41.802 43.1356 41.8413 43.0963C41.9857 42.9388 44.2957 40.4581 47.3013 43.2013C47.8001 43.6475 48.4563 43.4638 48.7845 42.7944C49.1126 42.1119 48.9813 41.2063 48.4826 40.76V40.7338Z" fill="${iconColor}"/>
        <path d="M48.4823 25.2726C46.1985 23.1857 44.1379 23.317 42.8254 23.7763C41.5785 24.2226 40.7385 25.0495 40.5023 25.312C37.5098 27.9895 35.226 25.5351 35.0816 25.3776C35.0423 25.3382 35.016 25.312 34.9766 25.2726C32.6929 23.1857 30.6323 23.317 29.3198 23.7763C28.0729 24.2226 27.2329 25.0495 26.9966 25.312C26.0385 26.1651 25.1591 26.4932 24.3848 26.5457V29.4988C25.5004 29.4463 26.8129 29.0132 28.2173 27.727C28.2566 27.7007 28.2829 27.6613 28.3223 27.622C28.3485 27.5957 30.6716 24.9445 33.7429 27.6876C33.9791 27.9501 34.806 28.777 36.066 29.2232C36.5254 29.3807 37.0766 29.512 37.6935 29.512C38.8485 29.512 40.2398 29.092 41.7229 27.7401C41.7623 27.7007 41.7885 27.6745 41.8279 27.6351C41.9723 27.4776 44.2823 24.997 47.2879 27.7401C47.7866 28.1863 48.4429 28.0026 48.771 27.3332C49.0991 26.6507 48.9679 25.7451 48.4691 25.2988L48.4823 25.2726Z" fill="${iconColor}"/>
        <path d="M48.4823 32.7274C46.1985 30.6405 44.1379 30.7718 42.8254 31.2312C41.5785 31.6774 40.7385 32.5043 40.5023 32.7668C37.5098 35.4443 35.226 32.9899 35.0816 32.8324C35.0423 32.793 35.016 32.7668 34.9766 32.7274C32.6929 30.6405 30.6323 30.7718 29.3198 31.2312C28.0729 31.6774 27.2329 32.5043 26.9966 32.7668C26.0385 33.6199 25.1591 33.948 24.3848 34.0005V36.9537C25.5004 36.9012 26.8129 36.468 28.2173 35.1818C28.2566 35.1555 28.2829 35.1162 28.3223 35.0768C28.3485 35.0505 30.6716 32.3993 33.7429 35.1424C33.9791 35.4049 34.806 36.2318 36.066 36.678C36.5254 36.8355 37.0766 36.9668 37.6935 36.9668C38.8485 36.9668 40.2398 36.5468 41.7229 35.1949C41.7623 35.1555 41.7885 35.1293 41.8279 35.0899C41.9723 34.9324 44.2823 32.4518 47.2879 35.1949C47.7866 35.6412 48.4429 35.4574 48.771 34.788C49.0991 34.1055 48.9679 33.1999 48.4691 32.7537L48.4823 32.7274Z" fill="${iconColor}"/>
      </svg>`;

    return this.getCachedSvgIcon('waterLevel', `${color}-${iconColor}`, svgMarkup, [22, 22], [11, 11]);
  };

  getDamMediumSvgColor = (percent) => {
    const p = parseFloat(percent);
    if (p > 100) return '#C70000';
    if (p > 80)  return '#FF0000';
    if (p > 50)  return '#003CFA';
    if (p > 30)  return '#00B050';
    return '#FFC000';
  };

  getDamMediumSvgIcon = (percent) => {
    const color = this.getDamMediumSvgColor(percent);
    const iconColor = getContrastColor(color);
    const svgPaths = `
      <path d="M24.4418 32.8988H15.7793L21.618 13.9988H24.2618L24.4418 32.8988Z" fill="${iconColor}"/>
      <path d="M45.9182 30.84C44.602 29.6588 43.4207 29.7263 42.6557 29.9963C41.9357 30.2438 41.452 30.7163 41.317 30.8625C39.5957 32.3813 38.2795 30.9863 38.1895 30.8963C38.167 30.8738 38.1557 30.8625 38.1332 30.84C36.817 29.6588 35.6357 29.7263 34.8707 29.9963C34.1507 30.2438 33.667 30.7163 33.532 30.8625C31.8107 32.3813 30.4945 30.9863 30.4045 30.8963C30.382 30.8738 30.3707 30.8625 30.3482 30.84C29.032 29.6588 27.8507 29.7263 27.0857 29.9963C26.2757 30.2775 25.7695 30.84 25.7132 30.8963C25.4545 31.1888 25.4207 31.7175 25.6457 32.0663C25.8707 32.415 26.2532 32.46 26.512 32.1563C26.5232 32.145 27.8732 30.6488 29.6395 32.19C29.7745 32.3363 30.2582 32.7975 30.9782 33.0563C31.732 33.3263 32.9245 33.3938 34.2407 32.2125C34.2632 32.19 34.2857 32.1788 34.297 32.1563C34.3082 32.145 35.6582 30.6488 37.4245 32.19C37.5595 32.3363 38.0432 32.7975 38.7632 33.0563C39.0332 33.1463 39.3482 33.2138 39.697 33.2138C40.3607 33.2138 41.1595 32.9775 42.0145 32.2125C42.037 32.19 42.0482 32.1788 42.0707 32.1563C42.1495 32.0663 43.4882 30.6713 45.2207 32.2125C45.502 32.4713 45.8845 32.3588 46.0757 31.9763C46.267 31.5938 46.1882 31.0763 45.907 30.8288L45.9182 30.84Z" fill="${iconColor}"/>
      <path d="M45.9182 26.3063C44.602 25.1251 43.4207 25.1926 42.6557 25.4626C41.9357 25.7101 41.452 26.1826 41.317 26.3288C39.5957 27.8476 38.2795 26.4526 38.1895 26.3626C38.167 26.3401 38.1557 26.3288 38.1332 26.3063C36.817 25.1251 35.6357 25.1926 34.8707 25.4626C34.1507 25.7101 33.667 26.1826 33.532 26.3288C31.8107 27.8476 30.4945 26.4526 30.4045 26.3626C30.382 26.3401 30.3707 26.3288 30.3482 26.3063C29.032 25.1251 27.8507 25.1926 27.0857 25.4626C26.2757 25.7438 25.7695 26.3063 25.7132 26.3626C25.4545 26.6551 25.4207 27.1838 25.6457 27.5326C25.8707 27.8813 26.2532 27.9263 26.512 27.6226C26.5232 27.6113 27.8732 26.1151 29.6395 27.6563C29.7745 27.8026 30.2582 28.2638 30.9782 28.5226C31.732 28.7926 32.9245 28.8601 34.2407 27.6788C34.2632 27.6563 34.2857 27.6451 34.297 27.6226C34.3082 27.6113 35.6582 26.1151 37.4245 27.6563C37.5595 27.8026 38.0432 28.2638 38.7632 28.5226C39.0332 28.6126 39.3482 28.6801 39.697 28.6801C40.3607 28.6801 41.1595 28.4438 42.0145 27.6788C42.037 27.6563 42.0482 27.6451 42.0707 27.6226C42.1495 27.5326 43.4882 26.1376 45.2207 27.6788C45.502 27.9376 45.8845 27.8251 46.0757 27.4426C46.267 27.0601 46.1882 26.5426 45.907 26.2951L45.9182 26.3063Z" fill="${iconColor}"/>
      <path d="M45.9182 22.0988C44.602 20.9175 43.4207 20.985 42.6557 21.255C41.9357 21.5025 41.452 21.975 41.317 22.1213C39.5957 23.64 38.2795 22.245 38.1895 22.155C38.167 22.1325 38.1557 22.1213 38.1332 22.0988C36.817 20.9175 35.6357 20.985 34.8707 21.255C34.1507 21.5025 33.667 21.975 33.532 22.1213C31.8107 23.64 30.4945 22.245 30.4045 22.155C30.382 22.1325 30.3707 22.1213 30.3482 22.0988C29.032 20.9175 27.8507 20.985 27.0857 21.255C26.2757 21.5363 25.7695 22.0988 25.7132 22.155C25.4545 22.4475 25.4207 22.9763 25.6457 23.325C25.8707 23.6738 26.2532 23.7188 26.512 23.415C26.5232 23.4038 27.8732 21.9075 29.6395 23.4488C29.7745 23.595 30.2582 24.0563 30.9782 24.315C31.732 24.585 32.9245 24.6525 34.2407 23.4713C34.2632 23.4488 34.2857 23.4375 34.297 23.415C34.3082 23.4038 35.6582 21.9075 37.4245 23.4488C37.5595 23.595 38.0432 24.0563 38.7632 24.315C39.0332 24.405 39.3482 24.4725 39.697 24.4725C40.3607 24.4725 41.1595 24.2363 42.0145 23.4713C42.037 23.4488 42.0482 23.4375 42.0707 23.415C42.1495 23.325 43.4882 21.93 45.2207 23.4713C45.502 23.73 45.8845 23.6175 46.0757 23.235C46.267 22.8525 46.1882 22.335 45.907 22.0875L45.9182 22.0988Z" fill="${iconColor}"/>
      <circle cx="31" cy="42" r="6" fill="${iconColor}"/>
    `;
    const svgMarkup = `<svg width="22" height="22" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="30" fill="${color}"/>
        ${svgPaths}
      </svg>`;

    return this.getCachedSvgIcon('damMedium', `${color}-${iconColor}`, svgMarkup, [22, 22], [11, 11]);
  };

  getDamLargeSvgColor = (percent) => {
    const p = parseFloat(percent);
    if (p > 100) return '#C70000';
    if (p > 80)  return '#FF0000';
    if (p > 50)  return '#003CFA';
    if (p > 30)  return '#00B050';
    return '#FFC000';
  };

  getDamLargeSvgIcon = (percent) => {
    const color = this.getDamLargeSvgColor(percent);
    const iconColor = getContrastColor(color);
    const svgPaths = `
      <path d="M24.4418 32.8988H15.7793L21.618 13.9988H24.2618L24.4418 32.8988Z" fill="${iconColor}"/>
      <path d="M45.9182 30.84C44.602 29.6588 43.4207 29.7263 42.6557 29.9963C41.9357 30.2438 41.452 30.7163 41.317 30.8625C39.5957 32.3813 38.2795 30.9863 38.1895 30.8963C38.167 30.8738 38.1557 30.8625 38.1332 30.84C36.817 29.6588 35.6357 29.7263 34.8707 29.9963C34.1507 30.2438 33.667 30.7163 33.532 30.8625C31.8107 32.3813 30.4945 30.9863 30.4045 30.8963C30.382 30.8738 30.3707 30.8625 30.3482 30.84C29.032 29.6588 27.8507 29.7263 27.0857 29.9963C26.2757 30.2775 25.7695 30.84 25.7132 30.8963C25.4545 31.1888 25.4207 31.7175 25.6457 32.0663C25.8707 32.415 26.2532 32.46 26.512 32.1563C26.5232 32.145 27.8732 30.6488 29.6395 32.19C29.7745 32.3363 30.2582 32.7975 30.9782 33.0563C31.732 33.3263 32.9245 33.3938 34.2407 32.2125C34.2632 32.19 34.2857 32.1788 34.297 32.1563C34.3082 32.145 35.6582 30.6488 37.4245 32.19C37.5595 32.3363 38.0432 32.7975 38.7632 33.0563C39.0332 33.1463 39.3482 33.2138 39.697 33.2138C40.3607 33.2138 41.1595 32.9775 42.0145 32.2125C42.037 32.19 42.0482 32.1788 42.0707 32.1563C42.1495 32.0663 43.4882 30.6713 45.2207 32.2125C45.502 32.4713 45.8845 32.3588 46.0757 31.9763C46.267 31.5938 46.1882 31.0763 45.907 30.8288L45.9182 30.84Z" fill="${iconColor}"/>
      <path d="M45.9182 26.3063C44.602 25.1251 43.4207 25.1926 42.6557 25.4626C41.9357 25.7101 41.452 26.1826 41.317 26.3288C39.5957 27.8476 38.2795 26.4526 38.1895 26.3626C38.167 26.3401 38.1557 26.3288 38.1332 26.3063C36.817 25.1251 35.6357 25.1926 34.8707 25.4626C34.1507 25.7101 33.667 26.1826 33.532 26.3288C31.8107 27.8476 30.4945 26.4526 30.4045 26.3626C30.382 26.3401 30.3707 26.3288 30.3482 26.3063C29.032 25.1251 27.8507 25.1926 27.0857 25.4626C26.2757 25.7438 25.7695 26.3063 25.7132 26.3626C25.4545 26.6551 25.4207 27.1838 25.6457 27.5326C25.8707 27.8813 26.2532 27.9263 26.512 27.6226C26.5232 27.6113 27.8732 26.1151 29.6395 27.6563C29.7745 27.8026 30.2582 28.2638 30.9782 28.5226C31.732 28.7926 32.9245 28.8601 34.2407 27.6788C34.2632 27.6563 34.2857 27.6451 34.297 27.6226C34.3082 27.6113 35.6582 26.1151 37.4245 27.6563C37.5595 27.8026 38.0432 28.2638 38.7632 28.5226C39.0332 28.6126 39.3482 28.6801 39.697 28.6801C40.3607 28.6801 41.1595 28.4438 42.0145 27.6788C42.037 27.6563 42.0482 27.6451 42.0707 27.6226C42.1495 27.5326 43.4882 26.1376 45.2207 27.6788C45.502 27.9376 45.8845 27.8251 46.0757 27.4426C46.267 27.0601 46.1882 26.5426 45.907 26.2951L45.9182 26.3063Z" fill="${iconColor}"/>
      <path d="M45.9182 22.0988C44.602 20.9175 43.4207 20.985 42.6557 21.255C41.9357 21.5025 41.452 21.975 41.317 22.1213C39.5957 23.64 38.2795 22.245 38.1895 22.155C38.167 22.1325 38.1557 22.1213 38.1332 22.0988C36.817 20.9175 35.6357 20.985 34.8707 21.255C34.1507 21.5025 33.667 21.975 33.532 22.1213C31.8107 23.64 30.4945 22.245 30.4045 22.155C30.382 22.1325 30.3707 22.1213 30.3482 22.0988C29.032 20.9175 27.8507 20.985 27.0857 21.255C26.2757 21.5363 25.7695 22.0988 25.7132 22.155C25.4545 22.4475 25.4207 22.9763 25.6457 23.325C25.8707 23.6738 26.2532 23.7188 26.512 23.415C26.5232 23.4038 27.8732 21.9075 29.6395 23.4488C29.7745 23.595 30.2582 24.0563 30.9782 24.315C31.732 24.585 32.9245 24.6525 34.2407 23.4713C34.2632 23.4488 34.2857 23.4375 34.297 23.415C34.3082 23.4038 35.6582 21.9075 37.4245 23.4488C37.5595 23.595 38.0432 24.0563 38.7632 24.315C39.0332 24.405 39.3482 24.4725 39.697 24.4725C40.3607 24.4725 41.1595 24.2363 42.0145 23.4713C42.037 23.4488 42.0482 23.4375 42.0707 23.415C42.1495 23.325 43.4882 21.93 45.2207 23.4713C45.502 23.73 45.8845 23.6175 46.0757 23.235C46.267 22.8525 46.1882 22.335 45.907 22.0875L45.9182 22.0988Z" fill="${iconColor}"/>
      <rect x="26" y="36" width="10" height="10" fill="${iconColor}"/>
    `;
    const svgMarkup = `<svg width="25" height="25" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" fill="${color}"/>
        ${svgPaths}
      </svg>`;

    return this.getCachedSvgIcon('damLarge', `${color}-${iconColor}`, svgMarkup, [25, 25], [13, 13]);
  };

  getReservoirSvgIcon = (color) => {
    const iconColor = getContrastColor(color);
    const svgMarkup = `<svg width="35" height="35" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 60L32.16 56.84C44.04 39.24 50 26.96 50 20C50 8.96 41.04 0 30 0C18.96 0 10 8.96 10 20C10 27.36 16.68 40.68 30 60Z" fill="${color}"/>
      <path d="M23.5 27H17L21.3812 12H23.3649L23.5 27Z" fill="${iconColor}"/>
      <path d="M42.7733 24.8924C41.6358 23.8466 40.615 23.9063 39.9539 24.1454C39.3317 24.3645 38.9137 24.7829 38.797 24.9123C37.3096 26.257 36.1721 25.0219 36.0943 24.9422C36.0749 24.9223 36.0651 24.9123 36.0457 24.8924C34.9082 23.8466 33.8874 23.9063 33.2263 24.1454C32.6041 24.3645 32.1861 24.7829 32.0694 24.9123C30.582 26.257 29.4445 25.0219 29.3667 24.9422C29.3473 24.9223 29.3375 24.9123 29.3181 24.8924C28.1806 23.8466 27.1598 23.9063 26.4987 24.1454C25.7987 24.3944 25.3613 24.8924 25.3126 24.9422C25.089 25.2012 25.0599 25.6693 25.2543 25.9781C25.4488 26.2869 25.7793 26.3267 26.0029 26.0578C26.0126 26.0478 27.1793 24.7231 28.7056 26.0877C28.8223 26.2171 29.2403 26.6255 29.8625 26.8546C30.5139 27.0937 31.5444 27.1534 32.6819 26.1076C32.7013 26.0877 32.7208 26.0777 32.7305 26.0578C32.7402 26.0478 33.9069 24.7231 35.4332 26.0877C35.5499 26.2171 35.9679 26.6255 36.5901 26.8546C36.8235 26.9343 37.0957 26.994 37.3971 26.994C37.9707 26.994 38.6609 26.7849 39.3998 26.1076C39.4192 26.0877 39.429 26.0777 39.4484 26.0578C39.5164 25.9781 40.6734 24.743 42.1705 26.1076C42.4136 26.3367 42.7441 26.2371 42.9094 25.8984C43.0747 25.5598 43.0066 25.1016 42.7636 24.8825L42.7733 24.8924Z" fill="${iconColor}"/>
      <path d="M42.7733 21.8924C41.6358 20.8466 40.615 20.9063 39.9539 21.1454C39.3317 21.3645 38.9137 21.7829 38.797 21.9123C37.3096 23.257 36.1721 22.0219 36.0943 21.9422C36.0749 21.9223 36.0651 21.9123 36.0457 21.8924C34.9082 20.8466 33.8874 20.9063 33.2263 21.1454C32.6041 21.3645 32.1861 21.7829 32.0694 21.9123C30.582 23.257 29.4445 22.0219 29.3667 21.9422C29.3473 21.9223 29.3375 21.9123 29.3181 21.8924C28.1806 20.8466 27.1598 20.9063 26.4987 21.1454C25.7987 21.3944 25.3613 21.8924 25.3126 21.9422C25.089 22.2012 25.0599 22.6693 25.2543 22.9781C25.4488 23.2869 25.7793 23.3267 26.0029 23.0578C26.0126 23.0478 27.1793 21.7231 28.7056 23.0877C28.8223 23.2171 29.2403 23.6255 29.8625 23.8546C30.5139 24.0937 31.5444 24.1534 32.6819 23.1076C32.7013 23.0877 32.7208 23.0777 32.7305 23.0578C32.7402 23.0478 33.9069 21.7231 35.4332 23.0877C35.5499 23.2171 35.9679 23.6255 36.5901 23.8546C36.8235 23.9343 37.0957 23.994 37.3971 23.994C37.9707 23.994 38.6609 23.7849 39.3998 23.1076C39.4192 23.0877 39.429 23.0777 39.4484 23.0578C39.5164 22.9781 40.6734 21.743 42.1705 23.1076C42.4136 23.3367 42.7441 23.2371 42.9094 22.8984C43.0747 22.5598 43.0066 22.1016 42.7636 21.8825L42.7733 21.8924Z" fill="${iconColor}"/>
      <path d="M42.7733 18.8924C41.6358 17.8466 40.615 17.9063 39.9539 18.1454C39.3317 18.3645 38.9137 18.7829 38.797 18.9123C37.3096 20.257 36.1721 19.0219 36.0943 18.9422C36.0749 18.9223 36.0651 18.9123 36.0457 18.8924C34.9082 17.8466 33.8874 17.9063 33.2263 18.1454C32.6041 18.3645 32.1861 18.7829 32.0694 18.9123C30.582 20.257 29.4445 19.0219 29.3667 18.9422C29.3473 18.9223 29.3375 18.9123 29.3181 18.8924C28.1806 17.8466 27.1598 17.9063 26.4987 18.1454C25.7987 18.3944 25.3613 18.8924 25.3126 18.9422C25.089 19.2012 25.0599 19.6693 25.2543 19.9781C25.4488 20.2869 25.7793 20.3267 26.0029 20.0578C26.0126 20.0478 27.1793 18.7231 28.7056 20.0877C28.8223 20.2171 29.2403 20.6255 29.8625 20.8546C30.5139 21.0937 31.5444 21.1534 32.6819 20.1076C32.7013 20.0877 32.7208 20.0777 32.7305 20.0578C32.7402 20.0478 33.9069 18.7231 35.4332 20.0877C35.5499 20.2171 35.9679 20.6255 36.5901 20.8546C36.8235 20.9343 37.0957 20.994 37.3971 20.994C37.9707 20.994 38.6609 20.7849 39.3998 20.1076C39.4192 20.0877 39.429 20.0777 39.4484 20.0578C39.5164 19.9781 40.6734 18.743 42.1705 20.1076C42.4136 20.3367 42.7441 20.2371 42.9094 19.8984C43.0747 19.5598 43.0066 19.1016 42.7636 18.8825L42.7733 18.8924Z" fill="${iconColor}"/>
    </svg>`;

    return this.getCachedSvgIcon('reservoir', `${color}-${iconColor}`, svgMarkup, [35, 35], [15, 15]);
  };

  setDamIcon = (storagePercent, type) => {
    if (type === 'medium') {
      return this.getDamMediumSvgIcon(storagePercent);
    }
    return this.getDamLargeSvgIcon(storagePercent);
  };

  setHighlightIcon = (storagePercent, type) => {
    const status = type === 'large'
      ? DamLargeColor(storagePercent)
      : DamMediumColor(storagePercent);
    const color = status.color.statusColor;

    if (storagePercent > 80) return <Dam5Icon style={{ fontSize: '5rem', fill: color }} />;
    if (storagePercent > 60) return <Dam4Icon style={{ fontSize: '5rem', fill: color }} />;
    if (storagePercent > 40) return <Dam3Icon style={{ fontSize: '5rem', fill: color }} />;
    if (storagePercent > 20) return <Dam2Icon style={{ fontSize: '5rem', fill: color }} />;
    return <Dam1Icon style={{ fontSize: '5rem', fill: color }} />;
  };

  // eachLargeDamData = (data, i) => {
  //   if (!data.dam?.dam_lat || !data.dam?.dam_long) return null;
  //   const position = [parseFloat(data.dam.dam_lat), parseFloat(data.dam.dam_long)];
  //   const icon = this.setDamIcon(parseFloat(data.dam_storage_percent).toFixed(2), 'large');
  //   return (
  //     <Marker key={`large-dam-${i}`} position={position} icon={icon}>
  //       <Tooltip>
  //         <span>
  //           <strong>{data.dam.dam_name?.th}</strong><br />
  //           {`จ.${data.geocode?.province_name?.th}`}<br />
  //           {`${parseFloat(data.dam_storage_percent).toFixed(0)}%`}
  //         </span>
  //       </Tooltip>
  //     </Marker>
  //   );
  // };

  eachMediumDamData = (data, i) => {
    if (!data.dam?.dam_lat || !data.dam?.dam_long) return null;
    const position = [parseFloat(data.dam.dam_lat), parseFloat(data.dam.dam_long)];
    const icon = this.setDamIcon(parseFloat(data.dam_storage_percent).toFixed(0), 'medium');
    const percent = parseFloat(data.dam_storage_percent).toFixed(0);
    const highlightIcon = this.setHighlightIcon(parseFloat(percent), 'medium');
    const color = DamMediumColor(percent);
    const { t } = this.props;

    return (
      <Marker key={`medium-dam-${i}`} position={position} icon={icon}>
        <Popup autoPan>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell padding="none" align="center" colSpan={2}>
                  <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                    {`${data.dam.dam_name?.th} ${t('จ.')} ${data.geocode?.province_name?.th}`}
                  </Box>
                </TableCell>
              </TableRow>
                <TableCell padding="none" align="center" colSpan={2}>
                  <Box display="flex" justifyContent="center" alignItems="center">
                    <Box>{highlightIcon}</Box>
                    <Box>
                      <span style={{ color: color.color.statusColor, fontSize: 24, fontWeight: 600 }}>
                        {`${percent}%`}
                      </span>
                    </Box>
                  </Box>
                  <Box mb={2} fontSize="16px" fontFamily="Kanit">
                    {t('ปริมาณน้ำกักเก็บปัจจุบัน (% รนก.)')}
                  </Box>
                </TableCell>
              <TableRow>
                <TableCell><Box fontWeight={600} fontSize={12}>{t('ปริมาณน้ำกักเก็บ')}</Box></TableCell>
                <TableCell align="right">{data.dam_storage}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><Box fontWeight={600} fontSize={12}>{t('น้ำไหลลง / ระบาย')}</Box></TableCell>
                <TableCell align="right">{data.dam_inflow} / {data.dam_released}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  <Box fontWeight={400} fontSize={12}>{`${t('หน่วย')} : (${t('ล้าน ลบ.ม.')})`}</Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Box fontSize="8px">{`${t('ข้อมูล')}: ${data.agency?.agency_name?.th}`}</Box>
                  <Box fontSize="8px">{`${t('ล่าสุด')} : ${data.dam_date}`}</Box>
                </TableCell>
                <TableCell align="right">
                  <Button
                    title={t('แสดงกราฟ')}
                    style={{ padding: 0, minWidth: 18 }}
                    onClick={() => {
                      const { handleModalOpen } = this.props;
                      handleModalOpen({
                        header: t('กราฟอ่างเก็บน้ำขนาดกลางรายวัน'),
                        content: <DamChartDailyMediumMain id={data.dam.id} agencyId={12} />,
                      });
                    }}
                  >
                    <FaChartLine />
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Popup>
        <Tooltip>
          <span>
            <strong>{data.dam.dam_name?.th}</strong><br />
            {`${t('ต.')}${data.geocode.tumbon_name.th} ${t('อ.')}${data.geocode.amphoe_name.th} `}<br />
            {`จ.${data.geocode?.province_name?.th}`}<br />
          </span>
        </Tooltip>
      </Marker>
    );
  };

  eachLargeDamData = (data, i) => {
    if (!data.dam?.dam_lat || !data.dam?.dam_long) return null;
    const { t } = this.props;
    const position = [parseFloat(data.dam.dam_lat), parseFloat(data.dam.dam_long)];
    const icon = this.setDamIcon(parseFloat(data.dam_storage_percent).toFixed(2), 'large');
    const percent = parseFloat(data.dam_storage_percent).toFixed(0);
    const highlightIcon = this.setHighlightIcon(parseFloat(percent), 'large');
    const color = DamLargeColor(percent);

    return (
      <Marker key={`large-dam-${i}`} position={position} icon={icon}>
        <Popup autoPan>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell padding="none" align="center" colSpan={2}>
                  <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                    {`${t('อ่างเก็บน้ำ')}${data.dam.dam_name?.th}`}
                  </Box>
                  <Box fontFamily="Kanit" fontSize="12px">
                    {`${t('จ.')}${data.geocode?.province_name?.th}`}
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell padding="none" align="center" colSpan={2}>
                  <Box display="flex" justifyContent="center" alignItems="center">
                    <Box>{highlightIcon}</Box>
                    <Box>
                      <span style={{ color: color.color.statusColor, fontSize: 24, fontWeight: 600 }}>
                        {`${percent}%`}
                      </span>
                    </Box>
                  </Box>
                  <Box mb={2} fontSize="16px" fontFamily="Kanit">
                    {t('ปริมาณน้ำกักเก็บปัจจุบัน (% รนก.)')}
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell><Box fontWeight={600} fontSize={12}>{t('ปริมาณน้ำกักเก็บ')}</Box></TableCell>
                <TableCell align="right">{data.dam_storage}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><Box fontWeight={600} fontSize={12}>{t('น้ำไหลลง / ระบาย')}</Box></TableCell>
                <TableCell align="right">{data.dam_inflow} / {data.dam_released}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  <Box fontSize={12}>{`${t('หน่วย')} : (${t('ล้าน ลบ.ม.')})`}</Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Box color="text.disabled" fontSize="8px">{`${t('ข้อมูล')} : ${data.agency?.agency_name?.th}`}</Box>
                  <Box color="text.disabled" fontSize="8px">{`${t('ล่าสุด')} : ${data.dam_date}`}</Box>
                </TableCell>
                <TableCell align="right">
                  <Button
                    title={t('แสดงกราฟ')}
                    style={{ padding: 0, minWidth: 18 }}
                    onClick={() => {
                      const { handleModalOpen } = this.props;
                      handleModalOpen({
                        header: t('กราฟอ่างเก็บน้ำรายวัน'),
                        content: <DamChartDailyMain id={data.dam.id} agencyId={12} />,
                      });
                    }}
                  >
                    <FaChartLine />
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Popup>
        <Tooltip>
          <span>
            <strong>{`${t('อ่างเก็บน้ำ')}${data.dam.dam_name?.th}`}</strong><br />
            {`${t('ต.')}${data.geocode.tumbon_name.th} ${t('อ.')}${data.geocode.amphoe_name.th} `}<br />
            {`จ.${data.geocode?.province_name?.th}`}<br />
          </span>
        </Tooltip>
      </Marker>
    );
  };

  eachRriStation = (feature, i) => {
    const { station, lat, lon, province, tambon, amphoe, STR_NAMT, Agency, id, name_th: geoNameTh } = feature.properties;
    if (!station || !lat || !lon) return null;
    const { onMarkerClick, rriLatestQr, waterlevelMeta, rriThresholds } = this.props;
    if (!waterlevelMeta || !Object.keys(waterlevelMeta).length) return null;
    if (!rriThresholds || !Object.keys(rriThresholds).length) return null;
    const position = [parseFloat(lat), parseFloat(lon)];

    const stationData = waterlevelMeta?.[id] ?? {};
    const name_th = stationData.station_name || geoNameTh || station;
    const oldcode = stationData.oldcode;

    const qr = stationData.discharge;
    const color = getRriStationColor(qr, rriThresholds?.[station]);

    const icon = this.getWaterLevelSvgIcon(color);

    return (
      <Marker key={`rri-station-${i}`} position={position} icon={icon}
        onClick={() => onMarkerClick?.({ type: 'station', name: station, province, amphoe, tambon, STR_NAMT, Agency, name_th, id, oldcode })}>
        <Tooltip>
          <span>
            <strong>{oldcode && `${oldcode} `} {name_th}</strong>
            {province && <><br />{`ต.${tambon} อ.${amphoe} จ.${province}`}</>}
          </span>
        </Tooltip>
      </Marker>
    );
  };

  eachRriReservoir = (feature, i) => {
    const { reservoir, lat, lon, province, tambon, amphoe, STR_NAMT, Agency, name_th, id, dam_id } = feature.properties;
    if (!reservoir || !lat || !lon) return null;
    const { onMarkerClick, rriLatestQr, datasLargeDam, datasMediumDam, damMeta } = this.props;
    const position = [parseFloat(lat), parseFloat(lon)];

    const allDams = [...(datasLargeDam ?? []), ...(datasMediumDam ?? [])];
    const damData = damMeta?.[dam_id];
    const percent = damData?.storage_percent ?? null;

    const isMedium = damData?.isMedium ?? false;
    const color = percent !== null
      ? (isMedium ? this.getDamMediumSvgColor(percent) : this.getDamLargeSvgColor(percent))
      : '#75808d';

    const icon = this.getReservoirSvgIcon(color);
    const cleanName = (damMeta?.[dam_id]?.dam_name ?? name_th ?? '')
      .replace(/(อ่างเก็บน้ำ\s*)+/g, 'อ่างเก็บน้ำ')
      .trim();
    const displayName = cleanName.startsWith('อ่างเก็บน้ำ') ? cleanName : `อ่างเก็บน้ำ${cleanName}`;

    return (
      <Marker key={`rri-reservoir-${i}`} position={position} icon={icon} 
        onClick={() => onMarkerClick?.({ type: 'reservoir', name: reservoir, name_th: damMeta?.[dam_id]?.dam_name ?? name_th, province, amphoe, tambon, STR_NAMT, Agency, id, dam_id, isMedium })}>
        <Tooltip>
          <span>
            <strong>{displayName}</strong>
            {province && <><br />{`ต.${tambon} อ.${amphoe} จ.${province}`}</>}
          </span>
        </Tooltip>
      </Marker>
    );
  };

  render() {
    const { location, zoom, sidebarOpen, onOpenSidebar, mainRiver, layers, basin, datas, waterLevel, rainfallEnabled, rainfallType, dataRainfall24, datasRainTodayMarker, datasRainYesterday, datasRain3day, datasRain7day, datasRain15Day, datasLargeDam, datasMediumDam, largeDamEnabled, mediumDamEnabled, t, rriStationEnabled, rriStations, rriTifUrl, rriReservoirEnabled, rriTifEnabled, datasRain30Day } = this.props;
    const { geojsonBasin, openLegendRRI, tiffTooltip, showInfo, openLegendObsRain, openLegendDamLarge, openLegendReservoir, openLegendStation  } = this.state;

    return (
      <>
        <Map
          id="map"
          center={location}
          zoom={zoom}
          ref={this.refMap}
          style={{
            height: '100%',
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            // zIndex: 1300,
          }}
          onMouseMove={this.handleMapMouseMove}
          onMouseOut={this.handleMapMouseOut}
        >

          <Control position="topleft">
            <button
              onClick={onOpenSidebar}
              style={{
                width: 36,
                height: 36,
                padding: 6,
                borderRadius: 8,
                border: '1px solid #F6F6F6',
                background: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                outline: 'none',
                visibility: sidebarOpen ? 'hidden' : 'visible',
                pointerEvents: sidebarOpen ? 'none' : 'auto',
              }}
            >
              <MenuIcon style={{ fontSize: 24, color: '#000000' }} />
            </button>
          </Control>

          {/* {largeDamEnabled && (
            <Control position="bottomleft">
              <div className="info">
                <Typography variant="body1">
                  <FontAwesomeIcon icon={faSquare} />
                  {' '}
                  {t('อ่างขนาดใหญ่')}
                  <br />
                  <FontAwesomeIcon icon={faCircle} />
                  {' '}
                  {t('อ่างขนาดกลาง')}
                </Typography>
              </div>
            </Control>
          )} */}

          <FullscreenControl position="topleft" />
          <CurrentLocation mapRef={this.refMap} showOnly={false} />

          <Control position="topleft">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
            <div
              style={{
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "2px",
                width: "30px",
                marginTop:"2px",
                height: "30px",
                marginLeft:"2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => this.setState(prev => ({ showInfo: !prev.showInfo }))}
            >
              <InfoOutlinedIcon style={{ color: '#000000' }} />
            </div>
          {showInfo && (
            <Paper elevation={3} style={{ borderRadius: "11px", overflow: "hidden", marginLeft: "5px" }}>
              <div style={{ maxWidth: "500px", fontFamily: "Kanit" }}>
                <div style={{
                  backgroundColor: "#ffffff",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}>
                  <InfoOutlinedIcon style={{ color: "#1C1B1F", fontSize: "20px", flexShrink: 0 }} />
                  <span style={{
                    fontFamily: "Kanit",
                    fontWeight: 700,
                    fontSize: "15px",
                    lineHeight: "1.3",
                    color: "#13263A",
                  }}>
                    {t("ระบบคาดการณ์น้ำท่าด้วยแบบจำลอง RRI")}
                  </span>
                </div>

                {/* Content */}
                <div style={{
                  padding: "10px 14px",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "12px",
                  marginTop:"-15px",
                  color: "#000000",
                }}>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("ระบบแบบจำลองน้ำฝน-น้ำท่า-น้ำท่วม ด้วยแบบจำลอง RRI (Rainfall-Runoff-Inundation Model) พัฒนาโดย ICHARM/PWRI ประเทศญี่ปุ่น เป็นแบบจำลองประเภท distributed model แบบ 2 มิติ ที่จำลองความสัมพันธ์น้ำฝนกับน้ำท่า และพื้นที่น้ำท่วมไปพร้อมกัน โดยผลลัพธ์เป็นปริมาณน้ำท่าและพื้นที่น้ำท่วมเชิงพื้นที่ในลักษณะกริด ระบบคาดการณ์น้ำท่าด้วยแบบจำลอง RRI เป็นส่วนหนึ่งของโครงการพัฒนาระบบจำลองน้ำฝน-น้ำท่าและการประยุกต์ใช้ข้อมูลฝนจากดาวเทียม เพื่อสนับสนุนการติดตามและคาดการณ์ความเสี่ยงน้ำท่วม-น้ำแล้งของประเทศไทย ครอบคลุมพื้นที่ลุ่มน้ำทั้ง 22 ลุ่มน้ำทั่วประเทศ ")}
                  </p>
                  <p style={{ margin: "0 0 2px 0" }}>
                    {t("ระบบปฏิบัติการประมวลผลอัตโนมัติทุกวัน เวลา 12.30 น. ประมวลผลลัพธ์เสร็จสิ้น เวลา 06.00-11.00 น. ของวันคาดการณ์ถัดไป (T+1) และแสดงผลปริมาณน้ำท่าคาดการณ์ ในรูปแบบรายสถานี และรายกริด")}
                  </p>
                </div>

                {/* Footer */}
                <div style={{
                  padding: "6px 14px 10px",
                  fontFamily: "Kanit",
                  fontWeight: 700,
                  fontSize: "12px",
                  color: "#13263A",
                }}>
                  {t("อ้างอิงเอกสารวิชาการ")}
                  <div style={{ fontWeight: 400, marginTop: "2px", display: "flex", flexDirection: "column", gap: "4px" }}>
                    <a href="https://www.sciencedirect.com/science/article/pii/S187770581503341X" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[1] The Application of Rainfall-Runoff-inundation (RRI) Model for Inundation Case in Upper Citarum Watershed, West Java-Indonesia")}
                    </a>
                    <a href="https://conference.thaince.org/index.php/ncce27/article/view/1473/1075" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[2] ASSESSING FLOOD HAZARD MAPPING OF CHAO PHRAYA RIVER BASIN USING RAINFALL-RUNOFF-INUNDATION (RRI) MODEL WITH VARIOUS RETURN PERIODSON THE BASIN")}
                    </a>
                  </div>
                </div>

              </div>
            </Paper>
          )}
          </div>
          </Control>
          
          <LayersControl position="topright">
            <BaseLayer name="OSM (default)" checked>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </BaseLayer>
            <BaseLayer name="ESRI">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri"
              />
            </BaseLayer>
            <BaseLayer name="Satellite">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community"
              />
            </BaseLayer>
            <BaseLayer name="Light">
              <TileLayer
                url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                attribution='&copy; OpenStreetMap contributors'
              />
            </BaseLayer>
            <BaseLayer name="Stadia">
              <TileLayer
                url={`https://{s}.tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token=${jawgToken}`}
                attribution='&copy; <a href="https://www.jawg.io">Jawg Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </BaseLayer>
            {/* <BaseLayer name="Carto">
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; OpenStreetMap contributors &copy; CARTO'
              />
            </BaseLayer> */}
            
          </LayersControl>
          {(rriTifEnabled && rriTifUrl) && (
            <Control position="bottomright">
              {openLegendRRI ? <LegendRRI /> : null}
              <Button
                variant="contained"
                  style={{
                    width: "152px",
                    height: "34px",
                    padding: "6px",
                    borderRadius: "4px",
                    border: "1px solid #BBCEDAE5",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "none",
                    textTransform: "none",
                    fontFamily: "Kanit",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "18px",
                    letterSpacing: "0px",
                    textAlign: "center",
                    zIndex: 99999,
                  }}
                aria-haspopup="true"
                onClick={this.handleClickLegendRRI}
                endIcon={
                  openLegendRRI
                    ? <KeyboardArrowUpIcon />
                    : <KeyboardArrowDownIcon />
                }
              >
                เกณฑ์สี RRI
              </Button>
            </Control>
          )}
          {rainfallEnabled && (
          <Control position="bottomright">
            {openLegendObsRain ? <LegendObsRain rainfallType={rainfallType} /> : null}
            <Button
              variant="contained"
                style={{
                  minWidth: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendObsRain}
              endIcon={
                openLegendObsRain
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              {RAINFALL_LEGEND_TITLE[rainfallType] || 'เกณฑ์ฝนตรวจวัด (มม.)'}
            </Button>
          </Control>
          )}
          {mainRiver && (
            <WMSTileLayer
              url={`${initPathWMS1}thaiwater30/wms`}
              version="1.1.0"
              opacity={1}
              transparent
              layers="thaiwater30:river_thailand"
              srs="EPSG:4326"
              format="image/png"
              tiled
              zIndex={200}
            />
          )}

          {layers?.basin && (
            <LayerGroup>
              <GeoJSON
                key={uniqueId()}
                data={geojsonBasin}
                style={this.getBasinStyle()}
                ref={this.refBoundaryBasin}
                onEachFeature={this.onEachBasinFeature}
              />
            </LayerGroup>
          )}

          {waterLevel && (
            <LayerGroup>
              {datas.map(this.eachData)}
            </LayerGroup>
          )}

          {rainfallEnabled && rainfallType && (
            <LayerGroup>
              {this.getRainfallMarkers()}
            </LayerGroup>
          )}

          {largeDamEnabled && (
            <LayerGroup>
              {datasLargeDam.map(this.eachLargeDamData)}
            </LayerGroup>
          )}

          {mediumDamEnabled && (
            <LayerGroup>
              {datasMediumDam.map(this.eachMediumDamData)}
            </LayerGroup>
          )}

          {largeDamEnabled && (
            <Control position="bottomright">
              {openLegendDamLarge ? <DamLargeLegendRRI /> : null}
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  style={{
                    height: "34px",
                    padding: "6px",
                    borderRadius: "4px",
                    border: "1px solid #BBCEDAE5",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "none",
                    textTransform: "none",
                    fontFamily: "Kanit",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "18px",
                    zIndex: 99999,
                  }}
                  aria-haspopup="true"
                  onClick={this.handleClickLegendDamLarge}
                  endIcon={openLegendDamLarge ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                >
                  {t('เกณฑ์สีอ่างขนาดใหญ่')}
                </Button>
              </div>
            </Control>
          )}

          {rriReservoirEnabled && (
            <Control position="bottomright">
              {openLegendReservoir ? <DamLargeLegendRRI /> : null}
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  style={{
                    width: "152px",
                    height: "34px",
                    padding: "6px",
                    borderRadius: "4px",
                    border: "1px solid #BBCEDAE5",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "none",
                    textTransform: "none",
                    fontFamily: "Kanit",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "18px",
                    zIndex: 99999,
                  }}
                  aria-haspopup="true"
                  onClick={this.handleClickLegendReservoir}
                  endIcon={openLegendReservoir ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                >
                  {t('เกณฑ์สีอ่างเก็บน้ำ')}
                </Button>
              </div>
            </Control>
          )}

          {rriStationEnabled && (
            <Control position="bottomright">
              {openLegendStation ? <DischargeLegend /> : null}
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  style={{
                    width: "152px",
                    height: "34px",
                    padding: "6px",
                    borderRadius: "4px",
                    border: "1px solid #BBCEDAE5",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "none",
                    textTransform: "none",
                    fontFamily: "Kanit",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "18px",
                    zIndex: 99999,
                  }}
                  aria-haspopup="true"
                  onClick={this.handleClickLegendStation}
                  endIcon={openLegendStation ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                >
                  {t('เกณฑ์สีระดับน้ำท่า')}
                </Button>
              </div>
            </Control>
          )}

          {(rriStationEnabled || rriReservoirEnabled) && (
            <LayerGroup>
              {rriStations.map((feature, i) => {
                const isStation = !!feature.properties?.station;
                if (isStation && rriStationEnabled) return this.eachRriStation(feature, i);
                if (!isStation && rriReservoirEnabled) return this.eachRriReservoir(feature, i);
                return null;
              })}
            </LayerGroup>
          )}

          {rriTifEnabled && rriTifUrl && (
            <RRIGeotiffLayerRRI
              key={rriTifUrl}
              layerRef={this.refGeotiffRri}
              url={rriTifUrl}
            />
          )}

        </Map>

      {tiffTooltip && (
        <div style={{
          position: 'fixed',
          left: tiffTooltip.x + 12,
          top: tiffTooltip.y - 19,
          width: 199,
          height: 38,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          paddingTop: 13,
          paddingBottom: 13,
          paddingLeft: 15,
          paddingRight: 15,
          border: '1px solid #BDBDBD',
          borderRadius: 11,
          backgroundColor: '#5a5a5a',
          boxSizing: 'border-box',
          pointerEvents: 'none',
          zIndex: 99999,
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        }}>
          <div style={{
            width: 18,
            height: 18,
            borderRadius: '50%',
            backgroundColor: tiffTooltip.color,
            border: '1px solid #FFFFFF',
            flexShrink: 0,
          }} />

          <span style={{
            fontFamily: 'Kanit',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '100%',
            color: '#ffffff',
            whiteSpace: 'nowrap',
          }}>
            ปริมาณการไหล {tiffTooltip.value} (m³/s)
          </span>
        </div>
      )}
      </>
    );
  }
}

RRIMap.propTypes = {
  location: PropTypes.array.isRequired,
  zoom: PropTypes.number.isRequired,
  handleSetMap: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  onOpenSidebar: PropTypes.func.isRequired,
  datas: PropTypes.array,
  waterLevel: PropTypes.bool,
  markers: PropTypes.array,
  handleModalOpen: PropTypes.func,
  rainfallEnabled: PropTypes.bool,
  rainfallType: PropTypes.string,
  dataRainfall24: PropTypes.array,
  datasRainTodayMarker: PropTypes.array,
  datasRainYesterday: PropTypes.array,
  datasRain3day: PropTypes.array,
  datasRain7day: PropTypes.array,
  datasRain15Day: PropTypes.array,
  datasLargeDam: PropTypes.array,
  datasMediumDam: PropTypes.array,
  largeDamEnabled: PropTypes.bool,
  mediumDamEnabled: PropTypes.bool,
  rriStationEnabled: PropTypes.bool,
  rriStations: PropTypes.array,
  rriTifUrl: PropTypes.string,
  rriReservoirEnabled: PropTypes.bool,
  onMarkerClick: PropTypes.func,
  rriLatestQr: PropTypes.object,
  datasRain30Day: PropTypes.array.isRequired,
  waterlevelMeta: PropTypes.object,
  damMeta: PropTypes.object,
};

export default compose(withWidth(), withStyles(styles), withTranslation())(RRIMap);
